export const Endpoints = {
    SEARCH_EVENTS_API: '/api/v1/SearchChallenges',
    ATHLETE_API: '/api/v1/athleteProfile',
    USER_SUMMARY_API: '/api/v1/UserSummary',
    ATHLETE_SOCIAL_API: '/api/v1/athleteSocial',
    ATHLETE_PROFILE_CONNECT_API: '/api/v1/athleteProfileConnect',
    ATHLETE_INVITE_API: '/api/v1/athleteInvite',
    ACHIEVEMENTS_API: '/api/v1/AthleteAchievements',
    JOIN_CHALLENGE_API: '/api/v1/JoinChallenge',
    DISCOVER_API: '/api/v1/ChallengeDiscovery',
    LOGIN_API: '/api/v1/login',
    EVENT_HISTORY_API: '/api/v1/challengeHistory',
    FETCH_STATES_API: '/api/v1/searchstates',
    FETCH_SALES_TAX_API: '/api/v1/JoinChallenge/GetSalesTax',
    PROMOTIONS_API: '/api/v1/promotions',
    VOUCHER_API: '/api/v1/voucher',
    REFRESH_API: 'api/v1/login/refresh',
    DISCOVER_EVENT_LIST_API: '/api/v1/DiscoverEventList',
    EVENT_LIST_API: '/api/v1/EventList',
    TRACK_PROGRESS_API: '​/api/v1/TrackProgress',
    EXERCISE_DETAIL_API: '/api/v1/ExerciseDetails',
    PASSWORD_RESET_API: '/api/v1/ResetPassword'
}

export const FACEBOOK_APP_ID = '573197069523922'
